import React, { useContext, useState } from "react";
import UsersContext from "../Context/UsersContext";
// icons imports
import { VscReferences } from "react-icons/vsc";
import { motion } from "framer-motion";
import DataContext from "../Context/DAtaContext";
import { BsFillTrash3Fill } from "react-icons/bs";
import { BsFillPeopleFill } from "react-icons/bs";
import VanoOverlay from "./VanoOverlay";
import { IoIosWarning } from "react-icons/io";
import supabase from "../Config/Supabase";
import { toast } from "react-toastify";

function VANOtable() {
  const { users } = useContext(UsersContext);
  const { Villages } = useContext(DataContext);
  const [notification, setNotification] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [VanoId, setVanoId] = useState("");
  const [VanodelId, setId] = useState();
  // const [VanoName, setVanoName] = useState("");

  // handle VanoName
  const VanoNam = users?.filter((dt) => dt?.id === VanodelId);
  const VanoName = VanoNam[0]?.name;
  // Filter users based on the search term
  const filteredUsers = users?.filter((user) =>
    user.name.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  // handle vano selection
  const handleVano = (id) => {
    setVanoId(id);
    setOpen(true);
  };

  // handle delete
  const handleDelete = async () => {
    const { data, error } = await supabase
      .from("user")
      .delete()
      .eq("id", VanodelId);

    if (error) {
      toast.error("Error deleting record:", error.message);
    } else {
      toast.success("Record deleted successfully:", data);
    }
  };

  return (
    <div className="relative">
      {/* table summary */}
      <div className="">
        <div className="flex flex-row items-center gap-2 mb-5">
          <VscReferences className="text-xl" />
          <h1 className="text-xs md:text-md">Table Summary</h1>
        </div>
        <div className="overflow-x-auto ">
          {/* Enables horizontal scrolling on small screens */}
          <motion.table
            className="w-full"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <thead className="">
              <tr className="bg-green-600 border-b md:text-sm">
                <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                  VANO Register
                </th>
                <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                  Achieved
                </th>
              </tr>
            </thead>
            <tbody className="">
              <motion.tr className="bg-white border-b hover:bg-green-100 ">
                <td className="p-2 text-xs text-gray-900 md:text-sm">
                  Enrolled
                </td>
                <td className="p-2 text-xs text-gray-900 md:text-sm">
                  {users?.length}
                </td>
              </motion.tr>
            </tbody>
          </motion.table>
        </div>
      </div>
      {/* Vano Table */}
      <div className="flex flex-row items-center mt-10 gap-x-2">
        <BsFillPeopleFill className="text-lg" />
        <h1 className="text-xs md:text-sm">Enrolled VANO</h1>
      </div>
      <div className="mt-4 mb-4">
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 px-2 text-xs border border-gray-300 rounded-md md:text-sm focus:outline-none focus:ring-1 focus:ring-green-400"
        />
      </div>
      <div className="relative overflow-y-auto max-h-96">
        {/* Table */}
        <table className="w-full ">
          <thead className="sticky top-0 z-20 text-white bg-green-600 shadow">
            <tr>
              <th className="p-2 text-xs text-left md:text-sm">No</th>
              <th className="p-2 text-xs text-left md:text-sm">Name</th>
              <th className="p-2 text-xs text-left md:text-sm">village</th>
              <th className="p-2 text-xs text-center md:text-sm ">Action</th>
            </tr>
          </thead>

          <motion.tbody
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {filteredUsers?.slice(0, 100)?.map((user, index) => {
              return (
                <motion.tr
                  key={user.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="transition duration-150 ease-in-out bg-white hover:bg-green-300"
                >
                  <td
                    onClick={() => handleVano(user?.id)}
                    className="p-2 text-xs border md:text-sm"
                  >
                    {index + 1}
                  </td>
                  <td
                    onClick={() => handleVano(user?.id)}
                    className="p-2 text-xs border md:text-sm"
                  >
                    {user?.name}
                  </td>

                  <td
                    onClick={() => handleVano(user?.id)}
                    className="p-2 text-xs border md:text-sm"
                  >
                    {(() => {
                      // filter out village
                      const vanoVillage = Villages?.filter(
                        (dt) => dt?.id === user?.village_id
                      );

                      return <span>{vanoVillage[0]?.name}</span>;
                    })()}
                  </td>
                  <td
                    onClick={() => setNotification(true)}
                    className="p-2 text-xs text-center border md:text-sm"
                  >
                    <button
                      onClick={() => setId(user?.id)}
                      className="px-2 py-1 text-white bg-red-600 rounded "
                    >
                      <BsFillTrash3Fill className="" />
                    </button>
                  </td>
                </motion.tr>
              );
            })}
          </motion.tbody>
        </table>
      </div>
      {/* Delete Notification */}
      {notification ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease: "easeInOut", type: "spring" }}
          className="absolute top-0 bottom-0 left-0 right-0 z-40 flex items-center justify-center w-full p-20 bg-black bg-opacity-15"
        >
          <div className="max-w-3xl px-4 py-4 bg-white shadow-xl md:p-10 rounded-xl">
            <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
              <IoIosWarning
                aria-hidden="true"
                className="w-6 h-6 text-red-600"
              />
            </div>
            <p className="max-w-md text-sm">
              Are you sure you want to delete this User
              <span className="font-medium">{VanoName}</span> ? note all data
              will be permanently removed. This action cannot be undone.
            </p>
            <div className="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6">
              <motion.button
                initial={{ opacity: 0, y: 90, scale: 0 }}
                animate={{ opacity: 1, scale: [1, 0, 1], y: 1 }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                  type: "spring",
                }}
                type="button"
                onClick={handleDelete}
                className="inline-flex justify-center w-full px-3 py-1 text-sm font-semibold text-white bg-red-600 rounded-md shadow-sm xl:py-2 hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                Delete
              </motion.button>
              <motion.button
                initial={{ opacity: 0, y: 90, scale: 0 }}
                animate={{ opacity: 1, scale: [1, 0, 1], y: 1 }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                  type: "spring",
                }}
                type="button"
                onClick={() => setNotification(false)}
                data-autofocus
                className="inline-flex justify-center w-full px-3 py-1 mt-3 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm xl:py-2 ring-1 ring-inset ring-black hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </motion.button>
            </div>
          </div>
        </motion.div>
      ) : (
        ""
      )}
      {/* VANO Overlay */}
      <div>
        <VanoOverlay VanoId={VanoId} open={open} setOpen={setOpen} />
      </div>
    </div>
  );
}

export default VANOtable;
